module.exports = __webpack_public_path__ + "static/media/goods8.faf37ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods8.png
// module id = 1238
// module chunks = 0